import { Injectable, inject } from "@angular/core";
import { RouteInfoService } from "./routeInfo.service";

@Injectable()
export class StorageService
{
    private readonly $routeInfoService = inject(RouteInfoService);


    get Tenant(): string
    {
        return this.$routeInfoService.tenant.toLowerCase();
    }

    Get<T>(key: string): T
    {
        const storedItem = this.getFullItem<T>(key);
        if (storedItem)
        {
            return storedItem[this.Tenant];
        }

        return null;
    }

    Remove(key: string): void
    {
        const storedItem = this.getFullItem(key);
        if (!storedItem)
        {
            return;
        }

        delete storedItem[this.Tenant];
        if (Object.keys(storedItem).length === 0)
        {
            localStorage.removeItem(key);
        }
        else
        {
            localStorage.setItem(key, JSON.stringify(storedItem));
        }
    }

    Set<T = unknown>(key: string, value: T): void
    {
        let storedItem = this.getFullItem<T>(key);
        if (!storedItem)
        {
            storedItem = {};
        }

        storedItem[this.Tenant] = value;
        const tenantedValue = JSON.stringify(storedItem);
        localStorage.setItem(key, tenantedValue);

        console.assert(localStorage.getItem(key) === tenantedValue, "AssertError: Value was not stored!");
    }

    private getFullItem<T = unknown>(key: string): Record<string, T>
    {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : undefined;
    }
}
